import { render, staticRenderFns } from "./ShareService.vue?vue&type=template&id=39d6c98e&scoped=true"
import script from "./ShareService.vue?vue&type=script&lang=ts"
export * from "./ShareService.vue?vue&type=script&lang=ts"
import style0 from "./ShareService.vue?vue&type=style&index=0&id=39d6c98e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d6c98e",
  null
  
)

export default component.exports